import React from "react";
import { useNavigate } from "react-router-dom";
import CardsWithCenterImage from "../../../components/cardsWIthCenterImage";
import FeatureCard from "../../../components/featuredCard";
import ImageTextCard from "../../../components/imageTextCard";
import LeftImageHeroSection from "../../../components/leftImageHeroSection";
import Footer from "./footer";

function LandingHome() {
  const card = [
    {
      title: "Data Scientist",
      image: "/job1.png",
      description:
        "Data scientists extract insights from complex datasets to drive decision-making and strategy. ",
    },
    {
      title: "Cybersecurity Experts",
      image: "/job2.png",
      description:
        "As technology advances, so do threats in the cyber world. Cybersecurity professionals are...",
    },
    {
      title: "AI and Robotics Engineers",
      image: "/job3.png",
      description:
        "Paradoxically, the field creating AI and automation is also one of the most future-pr...",
    },
    {
      title: "AI Product Manager",
      image: "/AI Product Manager.jpg",
      description:
        "AI product managers develop and implement strategies, lead the ideation, technical developm...",
    },
    {
      title: "AI Researcher",
      image: "AI Researcher.jpg",
      description:
        "AI Researchers are experts who make computers smarter. They create advanced programs that le...",
    },
    {
      title: "AI Ethicist",
      image: "AI Ethicist.jpg",
      description:
        "AI ethicist specialists evaluate AI systems for potential biases, ethical issues, and risks, and..",
    },
  ];

  const statsData = [
    {
      percentage: "60%",
      title: "IMF Report",
      description:
        "According to the  IMF AI is predicted to affect 40% of jobs globally, with that number rising to 60% in advanced economies",
      link: "https://www.imf.org/en/Blogs/Articles/2024/01/14/ai-will-transform-the-global-economy-lets-make-sure-it-benefits-humanity",
    },
    {
      percentage: "66%",
      title: "AI Skill Priority",
      description:
        "66% of business leaders prioritize AI skills: The majority of business leaders (66%) will not consider hiring a candidate who does not possess AI skills",
      link: "https://www.forbes.com/sites/jackkelly/2024/08/01/ai-skilled-workers-are-the-new-hot-in-demand-professionals/",
    },
    {
      percentage: "40%",
      title: "IBM Study",
      description:
        "IBM's study estimates that 40% of the global workforce (approximately 1.4 billion people) will need to reskill in the next three years due to AI implementation",
      link: "https://www.zdnet.com/article/40-of-workers-will-have-to-reskill-in-the-next-three-years-due-to-ai-says-ibm-study/",
    },
    {
      percentage: "85M",
      title: "Job Displacement",
      description:
        "A World Economic Forum report predicts that automation will replace 85 million jobs globally by 2025",
      link: "https://poconoupdate.com/85-million-jobs-will-be-replaced-by-artificial-intelligence-by-2025/",
    },
    {
      percentage: "92%",
      title: "Tech Reskilling",
      description:
        "A report from tech industry leaders suggests that 92% of roles within the information and communications technology sector are expected to undergo significant changes due to AI advancements",
      link: "https://hrreview.co.uk/hr-news/92-of-tech-jobs-require-reskilling-as-ai-revolutionises-the-it-sector/376270",
    },
    {
      percentage: "3.5x",
      title: "Job Growth",
      description:
        "Jobs requiring AI specialist skills are growing 3.5 times faster than all jobs combined",
      link: "https://www.pwc.com/gx/en/issues/artificial-intelligence/job-barometer/report.pdf",
    },
  ];

  const obj = [
    {
      description: "Assess your AI literacy and Job Impact",
    },
    {
      description: "Explore possibilities for automation",
    },
    {
      description: "Identify necessary skills to stay competitive",
    },
    {
      description: "Discover AI-resilient career options",
    },
  ];

  const navigate = useNavigate();
  return (
    <div>
      <LeftImageHeroSection
        label="Find Your Career Path in the AI-Economy"
        description="Assess your AI literacy, the impact of AI on your job, and receive recommendations to excel in your career"
        firstButton="Start the Quiz"
        firstButtonClass="w-[170px]"
        secondButton
        firstButtonClick={() => navigate("/auth/login")}
        secondButtonClick={() => navigate("/auth/login")}
        quote={
          "The future belongs to those who embrace Al and use it to their advantage."
        }
        quoteAuthor={"Jensen Huang, founder, President & CEO, NVIDIA"}
      />
      <ImageTextCard
        image="/group-pic.png"
        imageClass="w-[640px] h-auto"
        label="Prepare for an AI Driven Job Market"
        subTitle="AI is reshaping the workforce, and roles once handled by humans are now being performed by intelligent machines. Our AI Job Impact Assessment tool helps you understand how susceptible your job might be to automation (Replaced, Displaced, Complement, Augment and Elevate)  and provides personalized insights on adapting and future-proofing your career. Don't wait for change to happen – take control of your professional future today. This platform can help you:"
        obj={obj}
        pointIcon="/pink-check.png"
        pointIconClass="w-5 h-5 mt-2"
      />
      <CardsWithCenterImage statsData={statsData} />

      <FeatureCard
        label="Top AI-Resilient Jobs Of The Future"
        description=" Looking for secure, AI-resilient roles? Explore careers that thrive in
          an AI-driven economy and find out how you can transition into these
          future-proof positions."
        cards={card}
      />
      {/* <CustomerFeedback /> */}
      {/* <FAQSection faqs={faqs} /> */}
      <Footer />
    </div>
  );
}

export default LandingHome;
